import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, normalizeStyle as _normalizeStyle, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "md:px-20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "opacity-0" }, "a", -1)
const _hoisted_3 = { class: "mt-14 md:mt-20" }
const _hoisted_4 = { class: "flex flex-col items-center md:items-start md:flex-row justify-between w-full" }
const _hoisted_5 = { class: "flex flex-col items-center w-full" }
const _hoisted_6 = { class: "w-80 h-80 xl:h-screen xl:w-full" }
const _hoisted_7 = { class: "flex flex-col w-1/2 md:flex-row xl:flex-col 2xl:flex-row" }
const _hoisted_8 = { class: "flex flex-col w-1/2 items-start px-4" }
const _hoisted_9 = { class: "text-xl lg:text-3xl font-semibold" }
const _hoisted_10 = { class: "flex gap-2 text-2xl text-start font-bold" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg lg:text-2xl font-semibold mt-2 md:mt-6" }, "Cores:", -1)
const _hoisted_13 = { class: "flex gap-1" }
const _hoisted_14 = ["name", "value", "onClick"]
const _hoisted_15 = {
  key: 0,
  class: "text-lg md:text-2xl font-semibold mt-2 md:mt-6"
}
const _hoisted_16 = {
  key: 1,
  class: "flex gap-3"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg lg:text-2xl font-semibold mt-2 md:mt-6" }, " Quantidade ", -1)
const _hoisted_19 = { class: "flex gap-2 items-center mt-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg lg:text-2xl font-semibold mt-6" }, "Descrição", -1)
const _hoisted_22 = { class: "flex break-all w-52 md:w-72 text-cinza-padrao" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "w-1/2 mt-10 md:mt-0 flex flex-col md:items-center px-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg lg:text-2xl font-semibold" }, " Atributos do produto ", -1)
const _hoisted_26 = {
  key: 0,
  class: "p-1 lg:text-lg"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Gênero:", -1)
const _hoisted_28 = {
  key: 1,
  class: "p-1 lg:text-lg"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("strong", null, "Gênero:", -1)
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "p-1 lg:text-lg" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("strong", null, "Peso (kg):", -1)
const _hoisted_33 = { class: "p-1 lg:text-lg" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("strong", null, "Altura:", -1)
const _hoisted_35 = { class: "p-1 lg:text-lg" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("strong", null, "Largura:", -1)
const _hoisted_37 = { class: "p-1 lg:text-lg" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("strong", null, "Comprimento:", -1)
const _hoisted_39 = { class: "p-1 lg:text-lg" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("strong", null, "SKU:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElImage = _resolveComponent("ElImage")!
  const _component_ElCarouselItem = _resolveComponent("ElCarouselItem")!
  const _component_ElCarousel = _resolveComponent("ElCarousel")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_ctx.load)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.quickAddfunction(_ctx.selectedColor)))
      }, "a", 32))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ElCarousel, {
                  class: "m-auto w-72 h-72 sm:w-80 sm:h-80 lg:self-center lg:w-96 lg:h-96 xl:w-full xl:h-screen",
                  autoplay: false,
                  height: "auto"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productImages, (img) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: img.id,
                        class: "w-full h-full"
                      }, [
                        (img.color.find(color => color?.id == _ctx.selectedColor))
                          ? (_openBlock(), _createBlock(_component_ElCarouselItem, {
                              key: 0,
                              style: {"height":"auto"}
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_ElImage, {
                                  src:  img?.url,
                                  class: "w-72 h-72 sm:w-80 sm:h-80 lg:w-96 lg:h-96 xl:w-full xl:h-screen"
                                }, null, 8, ["src"]), [
                                  [_vShow, img.position == _ctx.position]
                                ])
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.productName), 1),
                _createElementVNode("div", _hoisted_10, [
                  (
                  _ctx.product.price_promotion &&
                  _ctx.product.price_promotion != 0 &&
                  !Number.isNaN(_ctx.product.price_promotion)
                )
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(_ctx.product.price_promotion)), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", {
                    class: _normalizeClass(
                  _ctx.product.price_promotion &&
                  _ctx.product.price_promotion != 0 &&
                  !Number.isNaN(_ctx.product.price_promotion)
                    ? 'text-xs text-center line-through'
                    : ''
                )
                  }, _toDisplayString(new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                    minimumFractionDigits: 2,
                  }).format(_ctx.product.price)), 3)
                ]),
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productColors, (colors) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: colors.id
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.attributes, (color) => {
                        return _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: color.id,
                          type: "radio",
                          name: 'product' + colors.id_product,
                          style: _normalizeStyle({ backgroundColor: color.color }),
                          class: "checked:border-2 checked:border-black cursor-pointer",
                          value: color.id,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedColor) = $event)),
                          onClick: ($event: any) => {_ctx.ableSizes(color.id);
                  
              _ctx.quickAddfunction(color.id);}
                        }, null, 12, _hoisted_14)), [
                          [_vModelRadio, _ctx.selectedColor]
                        ])
                      }), 128))
                    ]))
                  }), 128))
                ]),
                (
                _ctx.sizesOfProduct.length != 1 &&
                _ctx.sizesOfProduct[1] != 'Sem estoque'
              )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Tamanhos: "))
                  : _createCommentVNode("", true),
                (_ctx.sizesOfProduct[1] != 'Sem estoque')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sizesOfProduct.slice(1), (size) => {
                        return (_openBlock(), _createElementBlock("button", {
                          class: _normalizeClass(["p-1 font-bold", 
                  _ctx.selectedSize == size
                    ? 'bg-black text-white p-1 rounded font-bold'
                    : ''
                ]),
                          key: size,
                          onClick: ($event: any) => (_ctx.selectedSize = size)
                        }, _toDisplayString(size), 11, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.quantity >= 1 + 1 ? _ctx.quantity-- : (_ctx.quantity = 1))),
                    class: "font-semibold"
                  }, [
                    _createVNode(_component_Icon, { icon: "mdi:minus" })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    max: "10",
                    min: "1",
                    class: "w-16 rounded bg-cinza-padrao/20 py-1 focus:outline-none text-center font-bold",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quantity) = $event)),
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, _ctx.quantity]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.quantity <= 5 - 1 ? _ctx.quantity++ : (_ctx.quantity = 5))),
                    class: "font-semibold"
                  }, [
                    _createVNode(_component_Icon, { icon: "mdi:plus" })
                  ])
                ]),
                _createElementVNode("button", {
                  disabled: _ctx.sizesOfProduct[1] == 'Sem estoque',
                  class: _normalizeClass([
                _ctx.sizesOfProduct[1] == 'Sem estoque'
                  ? 'bg-azul-escuro'
                  : 'bg-azul-claro '
              , "rounded text-white text-lg font-bold w-52 h-12 mt-2 md:mt-6 md:h-12"]),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addToCart(_ctx.selectedColor, _ctx.selectedSize)))
                }, _toDisplayString(_ctx.sizesOfProduct[1] != 'Sem estoque'
                  ? _ctx.quickAddMessage
                  : _ctx.sizesOfProduct[1]), 11, _hoisted_20),
                _hoisted_21,
                _createElementVNode("p", _hoisted_22, [
                  _createElementVNode("span", { innerHTML: _ctx.productDescription }, null, 8, _hoisted_23)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", null, [
                  _hoisted_25,
                  (_ctx.productAttributes.gender == 'M')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                        _hoisted_27,
                        _createTextVNode(" masculino ")
                      ]))
                    : (_ctx.productAttributes.gender == 'F')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                          _hoisted_29,
                          _createTextVNode(" feminino ")
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_30)),
                  _createElementVNode("p", _hoisted_31, [
                    _hoisted_32,
                    _createTextVNode(" " + _toDisplayString(_ctx.productAttributes.Weight), 1)
                  ]),
                  _createElementVNode("p", _hoisted_33, [
                    _hoisted_34,
                    _createTextVNode(" " + _toDisplayString(_ctx.productAttributes.height), 1)
                  ]),
                  _createElementVNode("p", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(" " + _toDisplayString(_ctx.productAttributes.width), 1)
                  ]),
                  _createElementVNode("p", _hoisted_37, [
                    _hoisted_38,
                    _createTextVNode(" " + _toDisplayString(_ctx.productAttributes.comprimento), 1)
                  ]),
                  _createElementVNode("p", _hoisted_39, [
                    _hoisted_40,
                    _createTextVNode(" " + _toDisplayString(_ctx.productAttributes.sku), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
}